



















































































































































































































































































































































































import {API} from '@/services/api/api';
import {extractDetailsFromBase64} from '@/services/api/image';

import {Utils} from '@/utils/Utils';
import validator from '@/utils/validator';
import moment from 'moment';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {
    ...mapActions(['setInspectionData', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {
    ...mapGetters(['getInspectionData']),
  },
})
export default class InspectionSecondStep extends Vue {
  @Prop() isReadOnly!: boolean;
  @Prop() showHeaderText!: boolean;
  @Prop() canMappedData!: boolean;
  @Prop() showOnlyEditPage!: boolean;
  @Prop() showInspectorName!: boolean;
  @Prop() inspectorName!: boolean;

  setInspectionData: any;
  getInspectionData: any;
  isScreenLoading = true;
  showSuccessToast: any;
  showErrorToast: any;
  findings: any[];
  shipList: [];
  findingId: number = null;
  voyage = null;
  inspectionDateValiMsg = '';
  findingValidationMsg = '';
  frameValidationMsg = '';
  lengthValidationMsg = '';
  lengthUnitValidationMsg = '';
  severityValidationMsg = '';
  workOrderValiMsg = '';
  widthUnitValidationMsg = '';
  widthValidationMsg = '';
  voyageValidationMsg = '';

  firstStepData: any;
  lengthUnit: number = null;
  widthUnit: number = null;
  severties: any = [];
  severityId: number = null;
  workOrder = '';
  shipId: number = null;
  commonValidationMsg = 'This field is required';
  voyageConditionId: number = 0;
  voyagesData = [];
  isActive = true;

  inspectionDate = moment(new Date()).format('YYYY-MM-DD');
  reInspectionDate = moment(new Date()).add(1, 'M').format('YYYY-MM-DD');
  voyageConditionName = '';

  dimensionUnits = [
    {
      id: 1,
      name: 'mm',
    },
    {
      id: 2,
      name: 'cm',
    },
  ];

  workOrders = [
    {id: 1, name: 'To be Repaired'},
    {id: 2, name: 'To Be Observed'},
    {id: 3, name: 'To Be Evaluated'},
  ];

  voyageConditions = [];

  width: number = null;
  length: number = null;
  secondStepData: any;
  frame = '';
  isOpen = false;

  comment = '';
  isActionPlanReq = true;
  isActionPlanReq1 = true;

  imageData = [
    {
      fileName: '',
      imageDisplayURL: '',
      fileNameValiMsg: '',
      imageDescValiMsg: '',
      filePath: '',
      fileCaption: '',
      fileType: '',
      attachmentId: null,
    },
  ];

  mounted() {
    if (this.getInspectionData.firstStep !== undefined) {
      this.firstStepData = this.getInspectionData.firstStep;
      this.shipId = this.firstStepData.shipId;
      this.getDataFromAPIs();
    }
    if (this.getInspectionData.secondStep !== undefined) {
      this.secondStepData = this.getInspectionData.secondStep;
    }

    if (this.canMappedData) this.bindDataFieldsFromStore();
  }

  selectVoyageData(params) {
    this.voyage = params.voyageCode;
    this.isOpen = false;
  }

  /**
   * @param length 'length of rows of attachment'
   * @returns 'add empty  row in attchment section'
   */
  addImageRow(length) {
    if (length === 0 || this.validateImageData()) {
      this.imageData.push({
        fileName: '',
        imageDisplayURL: '',
        filePath: '',
        fileNameValiMsg: '',
        imageDescValiMsg: '',
        fileCaption: '',
        fileType: '',
        attachmentId: null,
      });
    }
  }
  /**
   * @param attachment cuurent object of attachment
   * @returns returns new array of attachment after deleting respective element
   */
  async deleteImageRow(attachment: any) {
    const attachmentId = attachment.attachmentId;

    if (attachmentId !== null) {
      try {
        attachment.isLoading = true;
        const response = await API.deleteAttchamentById(attachmentId);
        if (response.message) {
          const index = this.imageData.findIndex((data) => data === attachment);
          this.imageData.splice(index, 1);

          this.setInspectionData({
            key: 'secondStep',
            payload: {
              attachment: this.imageData.map((data) => {
                return {
                  fileType: data.fileType,
                  fileName: data.fileName,
                  filePath: data.filePath,
                  fileCaption: data.fileCaption,
                  attachmentId: data.attachmentId,
                };
              }),
            },
          });
          //

          this.showSuccessToast({msg: response.message});
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        this.showErrorToast({msg: 'Network Error'});
      } finally {
        attachment.isLoading = false;
      }
    } else {
      const index = this.imageData.findIndex((data) => data === attachment);
      this.imageData.splice(index, 1);
    }
  }
  validateImageData() {
    var isFieldValid: Boolean;
    this.imageData.forEach((image) => {
      if (validator.isNullOrEmpty(image.fileName)) {
        image.fileNameValiMsg = this.commonValidationMsg;
        isFieldValid = false;
        return false;
      } else {
        image.fileNameValiMsg = '';
        isFieldValid = true;
      }
      // if (validator.isNullOrEmpty(image.fileName)) {
      //   image.imageDescValiMsg = this.commonValidationMsg;
      //   isFieldValid = false;

      //   return false;
      // } else {
      //   image.imageDescValiMsg = '';
      //   isFieldValid = true;
      // }
    });

    return isFieldValid;
  }

  showSugeations() {
    this.isOpen = true;
    this.validateVoyage();
  }
  /**
   * @returns returns data of  from APIs which needed to setUp page
   */
  async getDataFromAPIs() {
    try {
      const findingReq = API.fetchInspectionFindings();
      const severityReq = API.fetchInspectionSeverity();
      const voyageReq = API.fetchInspectionVoyage(this.shipId, moment(this.inspectionDate).format('YYYY-MM-DD'));

      const voyageConditionsReq = API.fetchVoyageConditions();
      const response = await Promise.all([findingReq, severityReq, voyageReq, voyageConditionsReq]);
      this.findings = response[0].data;
      this.severties = response[1].data;
      this.voyagesData = response[2].data;
      this.voyageConditions = response[3].data;
    } catch (error) {
      this.showErrorToast({msg: error});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async getInspectionVoyage() {
    try {
      const response = await API.fetchInspectionVoyage(this.shipId, moment(this.inspectionDate).format('YYYY-MM-DD'));

      if (response.data) {
        const data = response.data;
        this.voyagesData = data;
      } else {
        console.error(response.error);

        // this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      console.error(e);
    }
  }

  async onFileChange(event: any, image: any) {
    this.isScreenLoading = true;
    const imageData = event.target.files[0];

    const index = this.imageData.findIndex((data) => data === image);

    try {
      let base64url = await Utils.ngxBase64(imageData);

      if (base64url === null || base64url === '') {
        alert('Something went wrong with image');
      } else {
        this.imageData[index].fileName = imageData.name;
        this.imageData[index].fileNameValiMsg = '';

        this.imageData[index].filePath = base64url;
        this.imageData[index].imageDescValiMsg = '';

        this.imageData[index].fileType = extractDetailsFromBase64(base64url).imageType;
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isScreenLoading = false;
    }
  }

  saveSecondStepData() {
    if (this.validateAll() && this.validateImageData()) {
      //
      this.setInspectionData({
        key: 'secondStep',
        payload: {
          inspectionDate: this.inspectionDate,
          voyage: this.voyage,
          voyageConditionId: this.voyageConditionId,
          findingId: this.findingId,
          frame: this.firstStepData.frameNumber,
          width: this.width,
          widthUnit: this.widthUnit,
          length: this.length,
          lengthUnit: this.lengthUnit,
          workOrder: this.workOrder,
          severityId: this.severityId,
          reInspectionDate: this.reInspectionDate,
          comment: this.comment,
          isActionPlanReq: this.isActionPlanReq,
          isActive: this.isActive,

          attachment: this.imageData.map((data) => {
            return {
              fileType: data.fileType,
              fileName: data.fileName,
              filePath: data.filePath,
              fileCaption: data.fileCaption,
              attachmentId: data.attachmentId,
            };
          }),
        },
      });
      //

      this.$emit('onNextClick', 2);
    }
  }

  validateInspectionDate() {
    if (validator.isNullOrEmpty(this.inspectionDate)) {
      this.inspectionDateValiMsg = this.commonValidationMsg;
      return false;
    } else {
      this.inspectionDateValiMsg = '';

      return true;
    }
  }

  validateFindings() {
    if (validator.isNullOrEmpty(this.findingId)) {
      this.findingValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.findingValidationMsg = '';
      return true;
    }
  }

  validateFrame() {
    //
    //   this.firstStepData.frameNumber,
    //   this.firstStepData.frameStart,
    //   this.firstStepData.frameEnd
    // );

    if (validator.isNullOrEmpty(this.firstStepData.frameNumber)) {
      this.frameValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.firstStepData.frameStart === null || this.firstStepData.frameEnd === null) {
      this.frameValidationMsg = '';
      return true;
    } else if (
      this.firstStepData.frameNumber < this.firstStepData.frameStart ||
      this.firstStepData.frameNumber > this.firstStepData.frameEnd
    ) {
      this.frameValidationMsg = 'Invalid frame value';
      return false;
    } else {
      this.frameValidationMsg = '';
      return true;
    }
  }
  validatelength() {
    if (validator.isNullOrEmpty(this.length)) {
      this.lengthValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.lengthValidationMsg = '';
      return true;
    }
  }
  validateUnitlength() {
    if (validator.isNullOrEmpty(this.lengthUnit)) {
      this.lengthUnitValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.lengthUnitValidationMsg = '';
      return true;
    }
  }

  validateWidth() {
    if (validator.isNullOrEmpty(this.width)) {
      this.widthValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.widthValidationMsg = '';
      return true;
    }
  }

  validateWidthUnit() {
    if (validator.isNullOrEmpty(this.widthUnit)) {
      this.widthUnitValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.widthUnitValidationMsg = '';
      return true;
    }
  }

  validateWorkOrder() {
    if (validator.isNullOrEmpty(this.workOrder)) {
      this.workOrderValiMsg = this.commonValidationMsg;
      return false;
    } else {
      this.workOrderValiMsg = '';
      return true;
    }
  }

  validateSeverity() {
    if (validator.isNullOrEmpty(this.severityId)) {
      this.severityValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.severityValidationMsg = '';
      return true;
    }
  }

  validateVoyage() {
    if (validator.isNullOrEmpty(this.voyage)) {
      this.voyageValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.voyageValidationMsg = '';
      return true;
    }
  }

  validateAll() {
    return (
      this.validateInspectionDate() &&
      this.validateVoyage() &&
      this.validateFindings() &&
      this.validateFrame() &&
      this.validatelength() &&
      this.validateUnitlength() &&
      this.validateWidth() &&
      this.validateWidthUnit() &&
      this.validateWorkOrder() &&
      this.validateSeverity()
    );
  }

  bindDataFieldsFromStore() {
    const data = this.getInspectionData.secondStep;
    const firstStepData = this.getInspectionData.firstStep;

    this.comment = data.comment;
    this.inspectionDate = data.inspectionDate;

    this.voyageConditionId = data.voyageConditionId;
    this.voyage = data.voyage;
    this.findingId = data.findingId;
    this.frame = data.frame;
    this.width = data.width;
    this.widthUnit = data.widthUnit;
    this.length = data.length;
    this.lengthUnit = data.lengthUnit;
    this.workOrder = data.workOrder;
    this.severityId = data.severityId;
    this.reInspectionDate = data.reInspectionDate;
    this.comment = data.comment;
    this.isActionPlanReq = data.isActionPlanReq;
    this.isActive = data.isActive;

    (this.firstStepData.frameStart = firstStepData.frameStart),
      (this.firstStepData.frameEnd = firstStepData.frameEnd),
      //
      //   'mapinfg data',
      //   this.firstStepData.frameStart,
      //   this.firstStepData.frameEnd
      // );

      //

      (this.imageData =
        data.attachment === undefined
          ? []
          : data.attachment.map((me) => {
              return {...me, isLoading: false};
            }));
  }

  @Watch('getInspectionData', {immediate: true})
  fetchZones() {
    if (this.getInspectionData.secondStep !== undefined) {
      this.secondStepData = this.getInspectionData.secondStep;
    }
  }

  @Watch('inspectionDate', {immediate: true})
  fetchVoyageData() {
    if (this.inspectionDate !== null && this.shipId !== null) this.getInspectionVoyage();
  }

  //
}
